export default __webpack_public_path__ + "static/media/angular.d4cb4fa5.svg";